import {
  Component,
  ElementRef,
  HostListener,
  WritableSignal,
  computed,
  inject,
  signal,
  output
} from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '../../core/services/layout.service';
import { CommonModule } from '@angular/common';
import { IconNameType } from '../icons/icon-name-type.enum';
import { IconComponent } from '../icons/icon.component';
import { TextButtonComponent } from '../text-button/text-button.component';
import { AuthService } from '../../core/services/auth.service';
import { StoreIdService } from '../../core/services/store-id.service';
import { ConfigService } from '../../core/services/config.service';
import { ModalName, ModalService } from '../../core/services/modal.service';
import { rotate } from '../animations/animations';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'cwo-account-button',
  standalone: true,
  imports: [CommonModule, IconComponent, TextButtonComponent, TranslocoDirective],
  templateUrl: './account-button.component.html',
  styleUrl: './account-button.component.scss',
  animations: [rotate('-180deg')],
})
export class AccountButtonComponent {
  router = inject(Router);
  modalService = inject(ModalService);
  authService = inject(AuthService);
  storeIdService = inject(StoreIdService)
  isLoggedIn = computed(() => this.authService.state().isLoggedIn);
  layoutService = inject(LayoutService);
  storeConfig = inject(ConfigService).configState().store;
  iconName = IconNameType;
  isProfilePage = false;
  isNotificationPage = false;
  isAddressPage = false;
  isWalletPage = false;
  isMyOrdersPage = false;
  isInviteFriendsPage = false;

  accountState = computed(() => this.authService.state().account);

  fullName = computed(() => {
    return `${this.accountState()?.firstName ?? ''} ${
      this.accountState()?.lastName ?? ''
    }`;
  });

  readonly buttonPressed = output();

  showDropdown: WritableSignal<boolean> = signal(false);

  private _eref = inject(ElementRef);

  constructor() {
    this.checkVisitStatus();
  }

  handleClick() {
    if (this.isLoggedIn()) {
      this.toggleDropdown();
    } else {
      this.modalService.closeAllModals().subscribe(() => {      
        this.modalService.openModal(ModalName.SignIn);
      });
    }
  }

  closeDropdown() {
    this.showDropdown.set(false);
  }

  toggleDropdown() {
    this.showDropdown.set(!this.showDropdown());
    this.checkVisitStatus();

    if (this.showDropdown()) {
      document.documentElement.style.setProperty('--header-z-index  ', '700');
    } else {
      document.documentElement.style.setProperty('--header-z-index', '200');
    }

    this.modalService.closeAllModals();
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.showDropdown.set(false);
      document.documentElement.style.setProperty('--header-z-index', '200');
    }
  }

  checkVisitStatus() {
    this.isProfilePage = this.router.url.includes('profile');
    this.isNotificationPage = this.router.url.includes('notification-options');
    this.isAddressPage = this.router.url.includes('address-book');
    this.isWalletPage = this.router.url.includes('wallet');
    this.isMyOrdersPage = this.router.url.includes('my-orders');
    this.isInviteFriendsPage = this.router.url.includes('invite-friends');
  }

  onLogout() {
    this.authService.logout().subscribe(() => {
      const pathname = location.pathname.split('/');

      window.location.href = `${pathname.length > 0 && `/${pathname[1]}`}/${
        this.storeIdService.getStorePathPrefix()
      }`;
    });
    this.closeDropdown()
  }
}
